export default __webpack_public_path__ + "static/5-5ca50026fa74f315cfe214aa04d7474a.png";